import React from "react";
import MenuBar from "../components/menuBarLoggedIn/menuBarLoggedIn.jsx";
import "../styles/aboutPage.css";
import aboutHeroImage from "../assets/images/about-hero-image.png";
import ourMissionImage from "../assets/images/Mission.png";
import meetTheBrainsImage from "../assets/images/meet-the-brains-image.png";
import Footer from "../components/footer";


const AboutPage = () => {
  return (
    <>
      <div>
        <MenuBar/>
        <main className="about-main">
          <section className="main-content">
            <article>
              <h1>
                We are Shuttle9ja
              </h1>
              <p>
                We are a passionate team of travel enthusiasts, who share a passion 
                for exploration and adventure and are determined to make bus travel
                easier, more convenient, and accessible for everyone.
              </p> 
              <p>
                We believe that every journey should be memorable, and we're
                dedicated to making sure that your bus travel experience is just that.
                Our team is constantly working to improve the platform and add new
                features that make bus travel even easier for our customers. Whether
                you're planning a weekend getaway, a family vacation, or a business trip, 
                Shuttle9Ja has you covered.
              </p>
              <a href="/">Discover now</a>
            </article>
            <img src={aboutHeroImage} alt="about hero"></img>
          </section>
          <section className="our-mission">
            <div className="our-mission-wrapper">
              <img src={ourMissionImage} alt=""></img>
              <article>
                <h2>
                  Our Mission
                </h2>
                <p>
                “ To revolutionize inter-state travel in Nigeria by providing a convenient and easy-to-use platform for booking bus services. Our goal is to make bus travel more accessible, affordable, and enjoyable for everyone. We believe that by connecting people and transforming travel, we can  have a positive impact on communities across the country. We're driven by a passion for innovation and a commitment to excellence. Whether you're a first-time traveler or a seasoned veteran, we want to make sure that your journey is as smooth and stress-free as possible.”
                </p>
              </article>
            </div>
          </section>
          <section className="our-values">
            <section className="our-values-wrapper">
              <h1>Our Values</h1>
              <p>Shuttle9ja is committed to delivering quality transportation services with integrity and innovation</p>
              <section>
                <article>
                  <h1>Convenience</h1>
                  <p>Shuttle9ja makes it easy and convenient for customers to compare and book bus services from various transport companies in Nigeria.</p>
                </article>
                <article>
                  <h1>Accessibility</h1>
                  <p>Shuttle9ja provides a platform for customers to book bus services and access information about various transport companies from anywhere, anytime</p>
                </article>
                <article>
                  <h1>Transparency</h1>
                  <p>Shuttle9ja provides transparent pricing and information about the transport companies available on its platform, allowing customers to make informed decisions</p>
                </article>
              </section>
            </section>
          </section>
          <section className="meet-the-brains">
            <section className="meet-the-brains-wrapper">
              <h1>Meet the brains behind <span>Shuttle9ja</span></h1>
              <img src={meetTheBrainsImage} alt="meet the brains"/>
            </section>
          </section>
        </main>
       <Footer />
      </div>
    </>
  );
};
export default AboutPage;